<div class="preview-panel">
  <div class="preview-header">
    <h2>{{ 'TEMPLATES.PREVIEW.TITLE' | translate }}</h2>
  </div>
  <div class="preview-content">
    @if (flattenedItems.length === 0) {
      <p class="empty-state">{{ 'TEMPLATES.PREVIEW.EMPTY_STATE' | translate }}</p>
    } @else {
      @for (item of flattenedItems; track item.id) {
        <div class="preview-item" [style.margin-left.px]="item.indentLevel * 16">
          <div class="title clickable" (click)="onItemClick(item.id)">
            {{ getItemText(item) }}
          </div>

          @if (item.contentBlocks.length > 0) {
            <div class="preview-blocks">
              @for (block of item.contentBlocks; track block.id; let isLast = $last) {
                <div class="preview-block">
                  @if (!isLast) {
                    <mat-divider></mat-divider>
                  }
                  <p>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.' + block.type | translate }}</p>
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
